import DateFnsUtils from '@date-io/date-fns'
import { yupResolver } from '@hookform/resolvers'
import DefaultAvatar from '@ifca-root/react-component/src/assets/images/default-avatar.png'
import theme from '@ifca-root/react-component/src/assets/theme'
import CardContents from '@ifca-root/react-component/src/components/CardList/CardContents'
import { Footer } from '@ifca-root/react-component/src/components/Footer/Footer'
import MainHeader from '@ifca-root/react-component/src/components/Header/MainHeader'
import { PhoneNumInput } from '@ifca-root/react-component/src/components/Input/PhoneNumInput'
import { ContentWrapper } from '@ifca-root/react-component/src/components/Layout/ContentWrapper'
import Loading from '@ifca-root/react-component/src/components/Loading/Loading'
import { changeDateFormat } from '@ifca-root/react-component/src/helpers/Functions/dateFunction'
import { default as useUploadImage } from '@ifca-root/react-component/src/utils/hooks/useUploadAttachment'
import {
  Button,
  Fab,
  Grid,
  IconButton,
  InputAdornment,
  MenuItem,
  Switch,
  TextField,
  useMediaQuery,
} from '@material-ui/core'
import { Publish } from '@material-ui/icons'
import { createFilterOptions } from '@material-ui/lab'
import {
  KeyboardDatePicker,
  MuiPickersUtilsProvider,
} from '@material-ui/pickers'
import irbmLogo from 'assets/einvoice/einvoice-irbm-logo.svg'
import { AddressAutoComponent } from 'components/AddressAutocomplete/AddressComponent'
import { ErrorDialog } from 'components/Dialog/ErrorDialog'
import { ExitConfirmationDialog } from 'components/Dialog/ExitConfirmationDialog'
import SnackBarContext from 'containers/App/Store/SnackBarContext'
import {
  GetCompanyDocument,
  RecordStatus,
  useAttachmentListingLazyQuery,
  useCheckInvalidTinNoLazyQuery,
  useCreateCompanyMutation,
  useDocumentListingQuery,
  useGetCompanyQuery,
  useGetCurrencyQuery,
  useGetPendingScheduledBillingProformaQuery,
  useUpdateCompanyMutation,
} from 'generated/graphql'
import { useAddressAutoComplete } from 'helpers/Hooks/useAddressAutoComplete'
import { SystemMsgs } from 'helpers/Messages/SystemMsg'
import { formatNo } from 'helpers/StringNumberFunction/FormatContactNo'
import { formatDashDate } from 'helpers/StringNumberFunction/FormatDate'
import { CommonYupValidation } from 'helpers/YupSchema/yup'
import React, { useContext, useEffect, useState } from 'react'
import { Controller, useForm, useFieldArray } from 'react-hook-form'
import { useHistory, useLocation, useParams } from 'react-router'
import { Delete, Add } from '@material-ui/icons'
import NumberFormat from 'react-number-format'
import * as yup from 'yup'

export interface CompanyProps {
  Name: string
  Address: string
  ContactNo: string
  Email: string
  CompanyRegNo: string
  CompanyTax: string
  Code: string
  GroupGSTRegNo: string
  GSTNo: string
  SSTNo: string
  TourismTaxNo: string
  GSTExpiryDate: string
  CurrencyID: string
  Country: string
  City: string
  State: string
  PostCode: string
  RecordStatus: boolean
  eInvIntegrated: boolean
  eSign: string
  Tin: string
  eSignExpiryDate: string
  eInvStartDate: string
  eInvEndDate: string
  eInvClientID: string
  eInvSecretKey: string
  eInvSecretKey2: string
  isProforma: boolean
  ConsolidatedLimitDetail: [{ Amount: number; EffectiveDate: Date }]
}

export const CompanyForm = (props: any) => {
  const { mode } = props
  const { CompanyID }: any = useParams()
  let formMode = mode === 'add' ? 'New' : 'Edit'
  let location = useLocation()
  let history = useHistory()
  const editData: any = location?.state
  const [openExitConf, setOpenExitConf] = useState(null)
  const latestCompany = localStorage.getItem('latestCompany')

  const eInvoiceSubscriber = JSON.parse(
    localStorage.getItem('eInvoiceSubscriber')
  )
  const { setOpenSnackBar, setSnackBarMsg }: any = useContext(
    SnackBarContext as any
  )
  const scheduledBillingEnv = !![
    'local',
    'azure',
    'internal',
    'axifcadev',
  ].includes(process.env.REACT_APP_LOCAL_DB)

  const {
    getCountry, // country
    getStatebyCountry, // State
    getCitybyState, // City
    getPostcodebyCity, // Postcode
    handleCountryOnChange,
    handleStateOnChange,
    handleCityOnChange,
    handlePostCodeOnChange,
    handleGoogleOnChange,
    query,
    autoCompleteRef,
    state,
    setQuery,
    initializeEditValue,
  } = useAddressAutoComplete()

  const [ogAddr, setOGAddr] = useState(null)
  const [addrValue, setAddress] = useState(null)
  const [country, setCountry] = useState('')
  const [states, setStates] = useState('')
  const [city, setCity] = useState('')
  const [postcode, setPostcode] = useState('')
  const [isChecked, setIsChecked] = useState(false)
  const [errorDia, setErrorDia] = useState(false)
  const [errMsg, setErrMsg] = useState('')
  const [errMessage, setErrMessage] = useState(null)
  const [errDialog, setErrDialog] = useState(false)

  const isDesktop = useMediaQuery(theme.breakpoints.up('sm'), {
    defaultMatches: true,
  })

  const filterOptions = createFilterOptions({
    matchFrom: 'start',
    stringify: (option: any) => option.Name,
  })

  useEffect(() => {
    if (mode === 'edit' && editData) {
      let array_of_address = [editData?.Address?.address]
      setQuery(array_of_address.join(', '))
      setOGAddr(array_of_address) //to compare if there is any changes
      setAddress(array_of_address?.slice(0))
      initializeEditValue({
        address: array_of_address.join(', '),
        country: editData?.Address?.country,
        state: editData?.Address?.state,
        city: editData?.Address?.city,
        postCode: editData?.Address?.postCode,
      })
    }
  }, [mode, editData])

  // const {
  //   fileMap,
  //   files,
  //   setFiles,
  //   previewMap,
  //   removeMappedFiles,
  //   handleUploadMapping,
  //   handleEditUploadMap,
  // } = useUploadAttachment()

  const {
    files: fileImage,
    handleSingleUpload: handleSingleUploadImage,
    previewFiles: previewFilesImage,
    removeSingleUpload: removeSingleImage,
    handleEditSingleUpload: handleEditSingleUploadImage,
  } = useUploadImage()

  const {
    loading: getPendingScheduledBillingProformaLoading,
    data: { getPendingScheduledBillingProforma } = {
      getPendingScheduledBillingProforma: [],
    },
  } = useGetPendingScheduledBillingProformaQuery({
    fetchPolicy: 'network-only',
    variables: { CompanyID: latestCompany },
    onError: ({ message }) => {
      let error = message?.substring(15)
      setErrMessage(error)
      setErrDialog(true)
    },
  })

  const {
    loading: DocLoading,
    data: { DocumentListing } = { DocumentListing: [] },
  } = useDocumentListingQuery({
    fetchPolicy: 'network-only',
    variables: { refID: CompanyID },
    onError: ({ message }) => {
      let error = message?.substring(15)
      setErrMessage(error)
      setErrDialog(true)
    },
  })

  const [
    loadAttachment,
    { loading: AttachmentLoading, data: attachmentData },
  ] = useAttachmentListingLazyQuery({
    fetchPolicy: 'network-only',
    onError: ({ message }) => {
      let error = message?.substring(15)
      setErrMessage(error)
      setErrDialog(true)
    },
    onCompleted: ({ attachmentListing }) => {
      handleEditSingleUploadImage(attachmentListing)
    },
  })

  const {
    loading: CurrencyLoading,
    data: { getCurrency } = { getCurrency: [] },
  } = useGetCurrencyQuery({
    fetchPolicy: 'network-only',
    onError: ({ message }) => {
      let error = message?.substring(15)
      setErrMessage(error)
      setErrDialog(true)
    },
  })

  const {
    loading: CompanyLoading,
    data: { getCompany } = { getCompany: [] },
  } = useGetCompanyQuery({
    fetchPolicy: 'network-only',
    onError: ({ message }) => {
      let error = message?.substring(15)
      setErrMessage(error)
      setErrDialog(true)
    },
  })

  const [
    createCompany,
    { loading: CreateLoading, data: createdCompanyData },
  ] = useCreateCompanyMutation({
    onError: ({ message }) => {
      let error = message?.substring(15)
      setErrMessage(error)
      setErrDialog(true)
    },
    onCompleted: data => {
      setOpenSnackBar(true)
      setSnackBarMsg(SystemMsgs.createNewRecord())
      setTimeout(() => {
        history.push({
          pathname: `/company-setup`,
          state: { success: true, msgMode: 'create' },
        })
      }, 500)
    },
  })

  const [
    updateCompany,
    { loading: UpdateCompanyLoading, data: updatedCompanyData },
  ] = useUpdateCompanyMutation({
    onError: ({ message }) => {
      let error = message?.substring(15)
      setErrMessage(error)
      setErrDialog(true)
    },
    onCompleted: data => {
      setOpenSnackBar(true)
      setSnackBarMsg(SystemMsgs.updateRecord())
      setTimeout(() => {
        history.push({
          pathname: `/company-setup/${CompanyID}/profile`,
          state: { success: true, msgMode: 'update' },
        })
      }, 500)
    },
  })

  const [
    getCheckInvalid,
    {
      loading: checkInvalidTinNoLoading,
      data: { checkInvalidTinNo } = { checkInvalidTinNo: false },
    },
  ] = useCheckInvalidTinNoLazyQuery({
    onCompleted: ({ checkInvalidTinNo }) => {
      if (checkInvalidTinNo) setIsChecked(false)
    },
    onError: e => {
      let error = e.message.substring(15)
      setErrorDia(true)
      setErrMsg(error)
      setIsChecked(false)
    },
  })

  const handleCheckInvalid = event => {
    setIsChecked(event.target.checked)
    getCheckInvalid({
      variables: {
        tinNo: watch('Tin'),
        identityNo: watch('CompanyRegNo'),
        identityType: 'BUSINESS_LICENSE',
      },
    })
  }

  useEffect(() => {
    register('RecordStatus')
    register('isProforma')
  }, [])

  const CompanyFormSchema = yup.object().shape({
    ContactNo: CommonYupValidation.requireField(SystemMsgs.contactNo()),
    Name: CommonYupValidation.requireField(SystemMsgs.companyName()),
    CompanyRegNo: CommonYupValidation.requireField(SystemMsgs.regNo()),
    Code: CommonYupValidation.requireField(SystemMsgs.companyCode()),
    CurrencyID: CommonYupValidation.requireField(SystemMsgs.baseCurrency()),
    Email: CommonYupValidation.email(),

    ...(eInvoiceSubscriber
      ? {
          SSTNo: yup.string().when('eInvIntegrated'.toString(), {
            is: true,
            then: yup.string().required(SystemMsgs.SSTRegNo()),
            otherwise: null,
          }),
          Tin: yup.string().when('eInvIntegrated'.toString(), {
            is: true,
            then: yup.string().required(SystemMsgs.tin()),
            otherwise: null,
          }),
          eInvStartDate: yup.string().when('eInvIntegrated'.toString(), {
            is: true,
            then: yup.string().required(SystemMsgs.eInvStartDate()),
            otherwise: null,
          }),
          eInvEndDate: yup.string().when('eInvIntegrated'.toString(), {
            is: true,
            then: yup.string().required(SystemMsgs.eInvEndDate()),
            otherwise: null,
          }),
          eInvClientID: yup.string().when('eInvIntegrated'.toString(), {
            is: true,
            then: yup.string().required(SystemMsgs.eInvClientID()),
            otherwise: null,
          }),
          eInvSecretKey: yup.string().when('eInvIntegrated'.toString(), {
            is: true,
            then: yup.string().required(SystemMsgs.eInvClientSecretKey()),
            otherwise: null,
          }),
          eInvSecretKey2: yup.string().when('eInvIntegrated'.toString(), {
            is: true,
            then: yup.string().required(SystemMsgs.eInvClientSecretKey2()),
            otherwise: null,
          }),
          ConsolidatedLimitDetail: yup
            .array()
            .of(
              yup.mixed().when('eInvIntegrated', {
                is: true,
                then: yup.object({
                  Amount: yup
                    .number()
                    .required(SystemMsgs.consolidationLimit())
                    .moreThan(0, 'Amount must be greater than 0'),
                  EffectiveDate: yup
                    .string()
                    .required(SystemMsgs.consolidationDate())
                    .test(
                      'later-or-equal-to-today',
                      'Date must be today or later',
                      date => {
                        const today = new Date()
                        today.setHours(0, 0, 0, 0)
                        if (new Date(date) < today) {
                          return false
                        }
                        return true
                      }
                    ),
                }),
                otherwise: yup
                  .mixed()
                  .nullable()
                  .default(null),
              })
            )
            .test('ascending-dates', null, function(consolidationItems: any) {
              if (!this.parent.eInvIntegrated) return true
              for (let i = 0; i < consolidationItems?.length - 1; i++) {
                if (
                  new Date(consolidationItems?.[i]?.EffectiveDate) >=
                  new Date(consolidationItems?.[i + 1].EffectiveDate)
                )
                  return this.createError({
                    path: `ConsolidatedLimitDetail[${i + 1}].EffectiveDate`,
                    message: 'Start date must be after the previous entry',
                  })
              }
              return true
            })
            .test('valid-dates', null, function(consolidationItems: any) {
              if (!this.parent.eInvIntegrated) return true
              for (let i = 0; i < consolidationItems?.length - 1; i++) {
                const { eInvStartDate, eInvEndDate } = this.parent

                const isDateValid =
                  new Date(eInvStartDate) <=
                    new Date(consolidationItems?.[i]?.EffectiveDate) &&
                  new Date(consolidationItems?.[i]?.EffectiveDate) <
                    new Date(eInvEndDate)

                if (!isDateValid)
                  return this.createError({
                    path: `ConsolidatedLimitDetail[${i}].EffectiveDate`,
                    message:
                      'Start date must be after the E-Invoice start date and before the E-Invoice end date',
                  })
              }
              return true
            }),
        }
      : null),
  })
  const {
    handleSubmit,
    register,
    watch,
    errors,
    control,
    setValue,
    unregister,
    formState: { isSubmitted },
  } = useForm<CompanyProps>({
    defaultValues: {
      Code: editData?.Code,
      Name: editData?.Name,
      Address: editData?.Address?.address,
      Country: editData?.Address?.country,
      State: editData?.Address?.state,
      City: editData?.Address?.city,
      PostCode: editData?.Address?.postCode,
      ContactNo: editData?.ContactNo,
      Email: editData?.Email,
      CompanyRegNo: editData?.CompanyRegNo,
      CompanyTax: editData?.CompanyTax,
      GroupGSTRegNo: editData?.GroupGSTRegNo,
      GSTNo: editData?.GSTNo,
      SSTNo: editData?.SSTNo,
      TourismTaxNo: editData?.TourismTaxNo,
      GSTExpiryDate: editData?.GSTExpiryDate,
      CurrencyID: editData?.BaseCurrencyID ?? editData?.Currency?.CurrencyID,
      RecordStatus:
        editData?.RecordStatus === RecordStatus.Inactive ? false : true,
      eInvIntegrated: editData?.eInvIntegrated ?? false,
      eSign: editData?.eSign ?? undefined,
      Tin: editData?.Tin ?? undefined,
      eSignExpiryDate: editData?.eSignExpiryDate,
      eInvStartDate: editData?.eInvStartDate,
      eInvEndDate: editData?.eInvEndDate,
      eInvClientID: editData?.eInvClientID,
      eInvSecretKey: editData?.eInvSecretKey,
      eInvSecretKey2: editData?.eInvSecretKey2,
      ...(scheduledBillingEnv && { isProforma: editData?.isProforma ?? false }),
      ConsolidatedLimitDetail: editData?.ConsolidatedLimitDetail || [
        {
          Amount: 0,
          EffectiveDate: `${new Date().getFullYear()}-${new Date().getMonth() +
            1}-${new Date().getDate()}`,
        },
      ],
    },
    mode: 'onSubmit',
    resolver: yupResolver(CompanyFormSchema),
  })
  const { fields, append, remove } = useFieldArray({
    control,
    name: 'ConsolidatedLimitDetail',
  })
  const addConsolidation = () => {
    append({
      Amount: 0,
      EffectiveDate: new Date(),
    })
  }

  const removeConsolidation = (index: number) => {
    setTimeout(() => {}, 100)
    remove(index)
  }

  useEffect(() => {
    if (mode === 'edit') {
      loadAttachment({ variables: { refID: editData?.CompanyID } })
      previewFilesImage?.push(editData?.Logo?.fileURL)
    }
  }, [mode, editData])

  const hasChanges = () => {
    const hasInfo =
      (watch('ParentCompanyID') !== '' &&
        watch('ParentCompanyID') !== undefined) ||
      (watch('Name') !== '' && watch('Name') !== undefined) ||
      (watch('Address') !== '' && watch('Address') !== undefined) ||
      (watch('Country') !== '' && watch('Country') !== undefined) ||
      (watch('State') !== '' && watch('State') !== undefined) ||
      (watch('ContactNo') !== '' && watch('ContactNo') !== undefined) ||
      (watch('PostCode') !== '' && watch('PostCode') !== undefined) ||
      (watch('CompanyRegNo') !== '' && watch('CompanyRegNo') !== undefined) ||
      (watch('CurrencyID') !== '' && watch('CurrencyID') !== undefined) ||
      watch('eInvIntegrated') !== undefined ||
      (watch('Tin') !== '' && watch('Tin') !== undefined)

    let prevData = {
      ParentCompanyID: editData?.ParentCompanyID,
      Name: editData?.Name,
      Address: editData?.Address?.address,
      City: editData?.Address?.city,
      State: editData?.Address?.state,
      PostCode: editData?.Address?.postCode,
      Country: editData?.Address?.country,
      ContactNo: editData?.ContactNo,
      CompanyRegNo: editData?.CompanyRegNo,
      CurrencyID: editData?.Currency?.CurrencyID,
      RecordStatus:
        editData?.RecordStatus === RecordStatus.Inactive ? false : true,
      isProforma: editData?.isProforma === true ? true : false,
    }
    let currentData = {
      ParentCompanyID: watch('ParentCompanyID'),
      Name: watch('Name'),
      Address: watch('Address'),
      City: watch('City'),
      State: watch('State'),
      PostCode: watch('PostCode'),
      Country: watch('Country'),
      ContactNo: watch('ContactNo'),
      CompanyRegNo: watch('CompanyRegNo'),
      CurrencyID: watch('CurrencyID'),
      RecordStatus: watch('RecordStatus'),
      isProforma: watch('isProforma'),
    }

    if (formMode === 'Edit') {
      if (JSON.stringify(prevData) === JSON.stringify(currentData)) return false
      else return true
    } else {
      if (hasInfo === true) return true
      else return false
    }
  }

  const handleCrudMutation = mode === 'add' ? createCompany : updateCompany

  const input = data => {
    return {
      ...(mode === 'add' ? { ID: editData?.ID } : null),
      ConsolidatedLimitDetail: data.ConsolidatedLimitDetail
        ? data.ConsolidatedLimitDetail?.map(item => ({
            Amount: item.Amount,
            EffectiveDate: formatDashDate(
              new Date(item.EffectiveDate)?.toISOString()
            ),
          }))
        : null,
      ParentCompanyID: data.ParentCompanyID,
      CompanyID: CompanyID,
      Name: data.Name,
      Code: data.Code,
      Address: {
        address: state.address,
        state: states ?? state.state.name,
        city: city ?? state.city.name,
        country: country ?? state.country.name,
        postCode: postcode ?? state.postcode.postcode,
      },
      ContactNo: formatNo(data.ContactNo),
      Email: data.Email,
      CompanyRegNo: data.CompanyRegNo,
      // CompanyTax: data.CompanyTax,
      GroupGSTRegNo: data.GroupGSTRegNo ?? null,
      GSTNo: data.GSTNo ?? null,
      GSTExpiryDate:
        formatDashDate(new Date(data?.GSTExpiryDate)?.toISOString()) ?? null,
      SSTNo: data.SSTNo ?? null,
      TourismTaxNo: data.TourismTaxNo ?? null,
      BaseCurrencyID: data.CurrencyID,
      LogoFiles: fileImage,
      RecordStatus:
        data?.RecordStatus === true
          ? RecordStatus?.Active
          : RecordStatus?.Inactive,
      ...(!!eInvoiceSubscriber
        ? {
            eInvIntegrated: !!data?.eInvIntegrated
              ? data?.eInvIntegrated
              : false,
            eSign: !!data?.eInvIntegrated ? data?.eSign : null,
            Tin: !!data?.eInvIntegrated ? data?.Tin : null,
            // eSignExpiryDate: !!data?.eInvIntegrated
            //   ? new Date(data?.eSignExpiryDate)
            //   : null,
            eInvStartDate: !!data?.eInvIntegrated
              ? formatDashDate(new Date(data?.eInvStartDate)?.toISOString())
              : null,
            eInvEndDate: !!data?.eInvIntegrated
              ? formatDashDate(new Date(data?.eInvEndDate)?.toISOString())
              : null,
            eInvClientID: !!data?.eInvIntegrated ? data?.eInvClientID : null,
            eInvSecretKey: !!data?.eInvIntegrated ? data?.eInvSecretKey : null,
            eInvSecretKey2: !!data?.eInvIntegrated
              ? data?.eInvSecretKey2
              : null,
          }
        : null),
    }
  }
  const onSubmit = (data, e) => {
    if (
      state.address
      // ====== Below commented to allow free text address ======
      // state.country.name &&
      // state.state.name &&
      // state.city.name &&
      // state.postcode.postcode
    ) {
      handleCrudMutation({
        variables: { input: input(data) },
        refetchQueries: [
          {
            query: GetCompanyDocument,
            variables: { CompanyID },
          },
        ],
      })
    }
  }
  const backPath =
    location?.pathname === `/company-setup/add`
      ? `/company-setup`
      : location?.pathname === `/company-setup/${CompanyID}/edit`
      ? `/company-setup/${CompanyID}/profile`
      : ''

  const user = JSON.parse(localStorage.getItem('loggedInUser'))

  return (
    <>
      {DocLoading && <Loading />}
      {CreateLoading && <Loading />}
      {CompanyLoading && <Loading />}
      {CurrencyLoading && <Loading />}
      {AttachmentLoading && <Loading />}
      {UpdateCompanyLoading && <Loading />}
      {getPendingScheduledBillingProformaLoading && <Loading />}
      <MainHeader
        mainBtn="close"
        onClick={() => {
          hasChanges() === true ? setOpenExitConf(true) : history.push(backPath)
        }}
        smTitle={'Company Setup'}
        title={user?.accountName}
        routeSegments={[
          { name: 'Company Listing' },
          { name: 'Company Profile', current: true },
        ]}
        rightRouteSegments={[{ name: formMode, current: true }]}
      />
      <ContentWrapper footer>
        {/* <form id="submit-form" > */}
        <CardContents section={{ header: { title: 'Company Form Details' } }}>
          <img
            src={previewFilesImage[0] ?? DefaultAvatar}
            alt=""
            className="upload-user-avatar"
          />
          <Fab
            color="primary"
            size="small"
            aria-label="add"
            className="float-img-upload "
          >
            <label htmlFor="icon-button-file"></label>
            <Publish />
          </Fab>
          <input
            type="file"
            hidden
            id="icon-button-file"
            onChange={handleSingleUploadImage}
            accept={'image/png, image/jpeg, image/gif'}
          />

          <Controller
            as={TextField}
            //id="standard-basic"
            name="Code"
            label="Company Code *"
            autoComplete="off"
            multiline={true}
            fullWidth
            margin="dense"
            helperText={errors?.Code?.message}
            error={errors?.Code ? true : false}
            ref={register}
            control={control}
            // required
            defaultValue={editData?.Code}
          />

          <Controller
            as={TextField}
            //id="standard-basic"
            name="Name"
            label="Company Name *"
            autoComplete="off"
            multiline={true}
            fullWidth
            margin="dense"
            helperText={errors?.Name?.message}
            error={errors?.Name ? true : false}
            ref={register}
            control={control}
            // required
            defaultValue={editData?.Name}
          />

          <Controller
            as={TextField}
            //id="standard-basic"
            name="CompanyRegNo"
            label="Registration No *"
            autoComplete="off"
            //multiline={true}
            fullWidth
            margin="dense"
            helperText={errors?.CompanyRegNo?.message}
            error={errors?.CompanyRegNo ? true : false}
            ref={register}
            defaultValue={editData?.CompanyRegNo}
            control={control}
            // required
          />

          <Controller
            as={TextField}
            name="GroupGSTRegNo"
            label="Group GST Registration No."
            autoComplete="off"
            fullWidth
            margin="dense"
            helperText={errors?.GroupGSTRegNo?.message}
            error={errors?.GroupGSTRegNo ? true : false}
            ref={register}
            defaultValue={editData?.GroupGSTRegNo}
            control={control}
          />

          <Controller
            as={TextField}
            //id="standard-basic"
            name="GSTNo"
            label="GST Registration No."
            autoComplete="off"
            className="left"
            margin="dense"
            helperText={errors?.GSTNo?.message}
            error={errors?.GSTNo ? true : false}
            ref={register}
            defaultValue={editData?.GSTNo}
            control={control}
            // required
          />

          <MuiPickersUtilsProvider utils={DateFnsUtils}>
            <Controller
              as={KeyboardDatePicker}
              name="GSTExpiryDate"
              label="GST Expiry Date"
              control={control}
              onChange={(date: Date | null) => {}}
              format="dd/MM/yyyy"
              value={watch(
                formMode === 'add'
                  ? new Date()
                  : editData?.GSTExpiryDate ?? new Date()
              )}
              margin="dense"
              allowKeyboardControl
              ref={register}
              KeyboardButtonProps={{
                'aria-label': 'change date',
              }}
              defaultValue={
                editData ? editData?.GSTExpiryDate ?? new Date() : new Date()
              }
              showTodayButton
              className="right"
            />
          </MuiPickersUtilsProvider>

          <Controller
            as={TextField}
            name="SSTNo"
            label="SST Registration No."
            autoComplete="off"
            fullWidth
            margin="dense"
            helperText={errors?.SSTNo?.message}
            error={errors?.SSTNo ? true : false}
            ref={register}
            defaultValue={editData?.SSTNo}
            control={control}
            required={!!watch('eInvIntegrated') ? true : false}
          />

          <Controller
            as={TextField}
            name="TourismTaxNo"
            label="Tourism Tax Registration No."
            autoComplete="off"
            fullWidth
            margin="dense"
            // helperText={errors?.SSTNo?.message}
            // error={errors?.SSTNo ? true : false}
            ref={register}
            defaultValue={editData?.TourismTaxNo}
            control={control}
            // required={!!watch('eInvIntegrated') ? true : false}
          />

          <Controller
            as={
              <TextField select>
                {getCurrency?.map((el, index) => (
                  <MenuItem
                    style={{ whiteSpace: 'normal' }}
                    value={el.ID}
                    key={index}
                  >
                    <span className="text-noflow">{el.name}</span>
                  </MenuItem>
                ))}
              </TextField>
            }
            name="CurrencyID"
            label="Base Currency *"
            autoComplete="off"
            margin="dense"
            fullWidth
            helperText={errors?.CurrencyID?.message}
            error={errors?.CurrencyID ? true : false}
            ref={register}
            defaultValue={
              editData?.BaseCurrencyID ?? editData?.Currency?.CurrencyID
            }
            control={control}
            // required
          />

          <Controller
            as={
              <PhoneNumInput
                country={user?.countryCode}
                specialLabel="Contact No. *"
              />
            }
            //id="standard-basic"
            name="ContactNo"
            type="tel"
            autoComplete="off"
            control={control}
            marginTop
            marginBottom
            fullWidth
            margin="dense"
            helperText={errors?.ContactNo?.message}
            error={errors?.ContactNo ? true : false}
            ref={register}
            defaultValue={editData?.ContactNo}
          />

          <Controller
            as={TextField}
            //id="standard-basic"
            name="Email"
            label="Email"
            autoComplete="off"
            multiline={true}
            fullWidth
            margin="dense"
            helperText={errors?.Email?.message}
            error={errors?.Email ? true : false}
            ref={register}
            control={control}
            required
            defaultValue={editData?.Email}
          />

          <Grid container>
            <AddressAutoComponent
              getCountry={getCountry}
              getStatebyCountry={getStatebyCountry}
              getCitybyState={getCitybyState}
              getPostcodebyCity={getPostcodebyCity}
              handleCountryOnChange={handleCountryOnChange}
              handleStateOnChange={handleStateOnChange}
              handleCityOnChange={handleCityOnChange}
              handlePostCodeOnChange={handlePostCodeOnChange}
              handleGoogleOnChange={handleGoogleOnChange}
              autoCompleteRef={autoCompleteRef}
              state={state}
              country={country}
              states={states}
              city={city}
              postcode={postcode}
              setCountry={setCountry}
              setStates={setStates}
              setCity={setCity}
              setPostcode={setPostcode}
            />
          </Grid>

          <div
            className="content-wrap left"
            style={{
              justifyContent: 'space-between',
              display: 'flex',
              alignItems: 'center',
              marginTop: '10px',
            }}
          >
            <span
              className="flex-space"
              style={{ fontSize: isDesktop ? 'auto' : '14px' }}
            >
              Active
            </span>

            <Switch
              checked={watch('RecordStatus')}
              onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                setValue('RecordStatus', event.target.checked)
              }}
              name="RecordStatus"
              color="primary"
            />
          </div>
          {scheduledBillingEnv && (
            <div
              className="content-wrap full"
              style={{
                justifyContent: 'space-between',
                display: 'flex',
                marginTop: '10px',
              }}
            >
              <span className="flex-space">To Implement Proforma Invoice</span>

              <Switch
                checked={watch('isProforma')}
                onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                  setValue('isProforma', event.target.checked)
                }}
                name="isProforma"
                color="primary"
                disabled={
                  getPendingScheduledBillingProforma?.proformaInvoices?.length >
                    0 ||
                  getPendingScheduledBillingProforma?.scheduledBilling?.length >
                    0
                }
              />
            </div>
          )}

          {eInvoiceSubscriber && (
            <>
              <div
                className="content-wrap right"
                style={{
                  justifyContent: 'space-between',
                  display: 'flex',
                  alignItems: 'center',
                  marginTop: '10px',
                }}
              >
                <span
                  className="flex-space"
                  style={{ fontSize: isDesktop ? 'auto' : '14px' }}
                >
                  Register e-Invoice
                </span>

                <Switch
                  onChange={event => {
                    if (event?.target?.checked === true) {
                      register('eSign')
                      register('Tin')
                      register('eSignExpiryDate')
                      register('eInvStartDate')
                      register('eInvEndDate')
                      setValue(
                        'eSignExpiryDate',
                        editData?.eSignExpiryDate ?? new Date()
                      )
                      setValue(
                        'eInvStartDate',
                        editData?.eInvStartDate ?? new Date()
                      )
                      setValue(
                        'eInvEndDate',
                        editData?.eInvEndDate ??
                          new Date(
                            new Date().setFullYear(
                              new Date().getFullYear() + 10
                            )
                          )
                      )
                    }
                  }}
                  name="eInvIntegrated"
                  color="primary"
                  inputRef={register()}
                  defaultChecked={editData?.eInvIntegrated ?? false}
                />
              </div>

              {watch('eInvIntegrated') === true && (
                <>
                  {/* <Controller
                    as={TextField}
                    name="Tin"
                    label="TIN *"
                    autoComplete="off"
                    fullWidth
                    margin="dense"
                    helperText={errors?.Tin?.message}
                    error={errors?.Tin ? true : false}
                    ref={register}
                    defaultValue={editData?.Tin}
                    control={control}
                    // required
                  /> */}

                  <Controller
                    required
                    as={TextField}
                    name="Tin"
                    label="TIN"
                    autoComplete="off"
                    fullWidth
                    margin="dense"
                    helperText={
                      !!errors?.Tin
                        ? errors?.Tin?.message
                        : checkInvalidTinNo
                        ? 'Invalid TIN'
                        : ''
                    }
                    error={!!errors?.Tin || checkInvalidTinNo}
                    ref={register}
                    defaultValue={editData?.Tin}
                    control={control}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <Button
                            size="small"
                            variant="contained"
                            onClick={handleCheckInvalid}
                            color="primary"
                            disabled={checkInvalidTinNoLoading}
                            style={{ marginBottom: 10 }}
                          >
                            <img alt="" src={irbmLogo} />
                          </Button>
                        </InputAdornment>
                      ),
                    }}
                  />

                  <MuiPickersUtilsProvider utils={DateFnsUtils}>
                    <Controller
                      as={KeyboardDatePicker}
                      name="eInvStartDate"
                      label="Start Date"
                      control={control}
                      onChange={(date: Date | null) => {}}
                      onAccept={(date: Date | null) => {
                        // set value eInvEndDate
                        setValue(
                          'eInvEndDate',
                          formatDashDate(
                            new Date(
                              date.setFullYear(date.getFullYear() + 10)
                            ).toISOString()
                          )
                        )

                        // revert back eInvStartDate to original year (IMPORTANT)
                        setValue(
                          'eInvStartDate',
                          formatDashDate(
                            new Date(
                              date.setFullYear(date.getFullYear() - 10)
                            ).toISOString()
                          )
                        )
                      }}
                      format="dd/MM/yyyy"
                      value={watch(
                        formMode === 'add'
                          ? new Date()
                          : editData?.eInvStartDate ?? new Date()
                      )}
                      margin="dense"
                      allowKeyboardControl
                      ref={register}
                      KeyboardButtonProps={{
                        'aria-label': 'change date',
                      }}
                      defaultValue={
                        editData
                          ? editData?.eInvStartDate ?? new Date()
                          : new Date()
                      }
                      showTodayButton
                      fullWidth
                      className="left"
                      helperText={errors?.eInvStartDate?.message}
                      error={errors?.eInvStartDate ? true : false}
                      required
                    />
                  </MuiPickersUtilsProvider>

                  <MuiPickersUtilsProvider utils={DateFnsUtils}>
                    <Controller
                      as={KeyboardDatePicker}
                      name="eInvEndDate"
                      label="End Date"
                      control={control}
                      onChange={(date: Date | null) => {}}
                      format="dd/MM/yyyy"
                      value={watch('eInvEndDate')}
                      margin="dense"
                      allowKeyboardControl
                      ref={register}
                      KeyboardButtonProps={{
                        'aria-label': 'change date',
                      }}
                      inputValue={`${changeDateFormat(
                        watch('eInvEndDate'),
                        'DD/MM/yyyy'
                      )}`}
                      defaultValue={
                        editData
                          ? editData?.eInvEndDate ??
                            new Date().setFullYear(
                              new Date().getFullYear() + 10
                            )
                          : new Date().setFullYear(
                              new Date().getFullYear() + 10
                            )
                      }
                      showTodayButton
                      fullWidth
                      className="right"
                      helperText={errors?.eInvEndDate?.message}
                      error={errors?.eInvEndDate ? true : false}
                      required
                    />
                  </MuiPickersUtilsProvider>

                  <Controller
                    as={TextField}
                    name="eInvClientID"
                    label="Client ID *"
                    autoComplete="off"
                    margin="dense"
                    helperText={errors?.eInvClientID?.message}
                    error={errors?.eInvClientID ? true : false}
                    ref={register}
                    defaultValue={editData?.eInvClientID}
                    control={control}
                    fullWidth
                    // required
                  />

                  <Controller
                    as={TextField}
                    name="eInvSecretKey"
                    label="Secret Key *"
                    autoComplete="off"
                    margin="dense"
                    helperText={errors?.eInvSecretKey?.message}
                    error={errors?.eInvSecretKey ? true : false}
                    ref={register}
                    defaultValue={editData?.eInvSecretKey}
                    control={control}
                    fullWidth
                    // required
                  />

                  <Controller
                    as={TextField}
                    name="eInvSecretKey2"
                    label="Secret Key 2 *"
                    autoComplete="off"
                    margin="dense"
                    helperText={errors?.eInvSecretKey2?.message}
                    error={errors?.eInvSecretKey2 ? true : false}
                    ref={register}
                    defaultValue={editData?.eInvSecretKey2}
                    control={control}
                    fullWidth
                    // required
                  />
                  {fields.map((consolidationItem, index) => (
                    <div
                      style={{ display: 'flex', width: '100%' }}
                      key={consolidationItem.id}
                    >
                      <Controller
                        name={`ConsolidatedLimitDetail.${index}.Amount`}
                        control={control}
                        rules={{ required: true }}
                        render={({ onChange, value }) => (
                          <NumberFormat
                            value={value}
                            onValueChange={vals => {
                              onChange(vals.floatValue ?? 0)
                            }}
                            thousandSeparator
                            allowNegative={false}
                            customInput={TextField}
                            label="Consolidate Amount *"
                            decimalScale={2}
                            fixedDecimalScale
                            margin="dense"
                            autoComplete="off"
                            allowLeadingZeros={false}
                            error={
                              !!errors?.ConsolidatedLimitDetail?.[index]?.Amount
                            }
                            helperText={
                              errors?.ConsolidatedLimitDetail?.[index]?.Amount
                                ?.message
                            }
                          />
                        )}
                      />
                      <MuiPickersUtilsProvider utils={DateFnsUtils}>
                        <Controller
                          name={`ConsolidatedLimitDetail.${index}.EffectiveDate`}
                          control={control}
                          render={({ value, onChange }) => (
                            <KeyboardDatePicker
                              style={{ marginLeft: '10px' }}
                              label={'Effective Date'}
                              value={value ? new Date(value) : null}
                              onChange={(date: Date | null) => {
                                if (!date) return onChange(null)
                                const yyyy = new Date(date).getFullYear()
                                const mm = String(date.getMonth() + 1).padStart(
                                  2,
                                  '0'
                                )
                                const dd = String(date.getDate()).padStart(
                                  2,
                                  '0'
                                )
                                onChange(`${yyyy}-${mm}-${dd}`)
                              }}
                              format="dd/MM/yyyy"
                              margin="dense"
                              allowKeyboardControl
                              KeyboardButtonProps={{
                                'aria-label': 'change date',
                              }}
                              showTodayButton
                              helperText={
                                errors?.ConsolidatedLimitDetail?.[index]
                                  ?.EffectiveDate?.message
                              }
                              error={
                                !!errors?.ConsolidatedLimitDetail?.[index]
                                  ?.EffectiveDate
                              }
                              required
                              fullWidth
                            />
                          )}
                        />
                      </MuiPickersUtilsProvider>
                      <div
                        style={{
                          display: 'flex',
                          justifyItems: 'center',
                          alignItems: 'center',
                        }}
                      >
                        <IconButton
                          color="inherit"
                          aria-label="open drawer"
                          edge="start"
                          onClick={() => removeConsolidation(index)}
                          style={{
                            marginLeft: '5px',
                            visibility:
                              index === fields.length - 1
                                ? 'visible'
                                : 'hidden',
                          }}
                        >
                          <Delete
                            htmlColor="white"
                            fontSize="medium"
                            style={{
                              width: '1.2rem',
                              height: '1.2rem',
                              background: 'red',
                              boxShadow: `0px 2px 2px 0px red`,
                              borderRadius: '3px',
                              color: 'rgba(255,255,255,100)',
                            }}
                          />
                        </IconButton>
                        <IconButton
                          color="inherit"
                          aria-label="open drawer"
                          edge="start"
                          onClick={addConsolidation}
                          style={{
                            marginLeft: '10px',
                            visibility:
                              index === fields.length - 1
                                ? 'visible'
                                : 'hidden',
                          }}
                        >
                          <Add
                            htmlColor="white"
                            fontSize="medium"
                            style={{
                              width: '1.2rem',
                              height: '1.2rem',
                              background: theme.palette.primary.main,
                              boxShadow: `0px 2px 2px 0px ${theme.palette.primary.main}`,
                              borderRadius: '3px',
                              color: 'rgba(255,255,255,100)',
                            }}
                          />
                        </IconButton>
                      </div>
                    </div>
                  ))}
                </>
              )}
            </>
          )}
        </CardContents>

        <Footer
          options={[
            {
              name: 'Save',
              onClick: () => {
                handleSubmit(onSubmit)()
              },
              color: 'primary',
            },
          ]}
        />
      </ContentWrapper>
      <ExitConfirmationDialog
        openExitConf={openExitConf}
        setOpenExitConf={setOpenExitConf}
        onConfirm={() => {
          history.push(backPath)
        }}
      />
      <ErrorDialog
        errorMsg={errMsg}
        errorDia={errorDia}
        setErrorDia={setErrorDia}
        errorHeaderMsg={'Error!'}
      />
    </>
  )
}
